<template>
    <div class="menu" :class="{'is-mobile': isMobile}">
        <span class="menu-toggle open-btn" @click="toggle">
            <fa-icon icon="bars" />
        </span>
        <div class="menu-overlay" @click="toggle" v-if="show && isMobile">
        </div>
        <div
            class="menu-items-wrapper"
            :class="{['slide-out']: show}"
        >
            <div class="menu-toggle close-btn" @click="toggle">
                <fa-icon icon="times" />
            </div>
            <div class="menu-items">
                <span class="nav-link-wrapper find-game-link" @click="close">
                    <router-link to="/rooms" class="nav-link" >
                        Find a game
                    </router-link>
                </span>
                <span class="nav-link-wrapper hide-on-small" @click="close" v-if="isSignedIn">
                    <router-link to="/recent-matches" class="nav-link">
                        Recent Matches
                    </router-link>
                </span>
                <span class="nav-link-wrapper" @click="close">
                    <router-link to="/leaderboard" class="nav-link">
                        Leaderboard
                    </router-link>
                </span>
                <span class="nav-link-wrapper hide-on-small" @click="close" v-if="isSignedIn">
                    <router-link to="/users" class="nav-link">
                        Community
                    </router-link>
                </span>
                <span class="nav-link-wrapper" @click="close" v-if="isSignedIn">
                    <router-link to="/matches" class="nav-link">
                        My games
                    </router-link>
                </span>
                <span class="nav-link-wrapper" @click="close">
                    <router-link to="/how-to-play" class="nav-link">
                        How to play
                    </router-link>
                </span>
                <span class="nav-link-wrapper" @click="close">
                    <router-link to="/contact-us" class="nav-link">
                        Contact
                    </router-link>
                </span>
                <span class="nav-link-wrapper" @click="close" v-if="!isSignedIn">
                    <router-link :to="{ name: 'login' }" class="nav-link">
                        Login
                    </router-link>
                </span>
                <span class="nav-link-wrapper" @click="close" v-if="!isSignedIn">
                    <router-link :to="{ name: 'login', params: { action: 'signUp' }}" class="nav-link">
                        Sign up
                    </router-link>
                </span>
                <span class="nav-link-wrapper" @click="close" v-if="isSignedIn">
                    <span class="nav-link nav-link-user" @click="onLogout">
                        Logout
                    </span>
                </span>
                <span class="nav-link-wrapper" @click="close" v-if="isSignedIn">
                    <router-link to="/profile" class="nav-link icon-link">
                        <span class="user-icon-wrapper">
                            <fa-icon icon="user" class="icon" />
                        </span>
                    </router-link>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { MOBILE_MAX_WIDTH } from '../../App-types';
import { loginInitialState } from '../Login/Login-state';
import { isMobileDevice } from '../../helpers/general';

export default {
    name: 'NavMenu',
    async created() {
        window.addEventListener('resize', this.onWindowResize);
    },
    unmounted() {
        window.removeEventListener('resize', this.onWindowResize);
    },
    data() {
        return {
            show: false,
            windowWidth: window.innerWidth,
        };
    },
    computed: {
        isMobile() {
            return this.windowWidth <= MOBILE_MAX_WIDTH || isMobileDevice();
        },
        isSignedIn() {
            return this.$store.state.loginState.userId;
        },
    },
    methods: {
        close() {
            this.show = false;
        },
        toggle() {
            this.show = !this.show;
        },
        onLogout() {
            this.$store.dispatch('setAuthDetails', loginInitialState);

            if (this.$route.name === 'profile') {
                this.$router.push('/');
            }

            this.$notify({
                group: 'app',
                title: 'Success',
                type: 'success',
                text: 'You have successfully signed out!',
            });
        },
        onWindowResize() {
            this.windowWidth = window.innerWidth;
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .menu {

        .menu-overlay {
            height: 100%;
            left: 0;
            position: absolute;
            top: 0;
            width: 100%;
            z-index: 1;
        }

        .menu-items-wrapper {
            background: $dark-brown;
            position: fixed;
            width: 74%;
            max-width: 300px;
            height: 100%;
            top: 0;
            right: -74%;
            z-index: 205;
            padding-top: 25px;
            box-sizing:  border-box;
            transition: right .25s linear;

            &.slide-out {
                right: 0;
                box-shadow: 1px 1px 3px 4px $extra-dark-brown;
            }

            .menu-items {
                line-height: 35px;
                margin-top: 30px;
                vertical-align: middle;
                display: flex;
                flex-direction: column-reverse;

                .nav-link {
                    display: block;
                    margin-bottom: 5px;
                    position: relative;
                    color: $light-gray;
                    transition: color .15s ease-in-out;
                    text-decoration: none;
                    cursor: pointer;

                    &:not(.icon-link) {

                        &:hover {
                            color: $gold;
                        }
                    }
                }

                .user-icon-wrapper {
                    width: 27px;
                    height: 27px;
                    background: $light-gray;
                    border-radius: 50%;
                    overflow: hidden;
                    vertical-align: middle;
                    display: inline-block;
                    transition: all .15s ease-in-out;

                    .icon {
                        transition: all .15s ease-in-out;
                        color: $sage-brown;
                        font-size: 1.25em;
                        margin-bottom: -1px;
                    }
                }
            }
        }

        .menu-toggle {
            color: $light-gray;
            font-size: 1.5em;
            cursor: pointer;

            &.close-btn {
                position: absolute;
                right: 20px;
                top: 10px;
            }
        }
    }

    @media only screen and (min-width: $screen-sm) {

        .menu {

            .menu-toggle {
                display: none;
            }

            .menu-items-wrapper {
                position: relative;
                width: auto;
                height: auto;
                top: initial;
                right: initial;
                border-left: none;
                padding: 0;
                max-width: none;
                z-index: 2;

                &.slide-out {
                    box-shadow: none;
                }

                .menu-items {
                    margin-top: 0;
                    display: block;

                    .nav-link {
                        display: inline-block;
                        margin-bottom: auto;
                        margin-left: 1.05rem;

                        &:not(.icon-link) {

                            &:after {
                                transform: translateY(-150%);
                                opacity: 0;
                                display: block;
                                position: absolute;
                                right: 0;
                                left: 0;
                                width: 100%;
                                height: 2px;
                                transition: transform .15s ease-in-out, opacity .15s ease-in-out;
                                background-color: $gold;
                                content: '';
                                margin-top: -2px;
                            }

                            &:hover {

                                &:after {
                                    transform: translateY(0);
                                    opacity: 1;
                                }
                            }
                        }
                    }
                }
            }

            .hide-on-small {
                display: none;
            }
        }
    }

    @media only screen and (min-width: 1000px) {

        .menu {

            .hide-on-small {
                display: inline-block;
            }
        }
    }

</style>
